<template>
  <svg
    viewBox="0 0 80 32"
    height="32"
    class="logo"
    alt="CAISO GRIP Logo"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <svg:style>
        .cls-1 {
        fill: url(#linear-gradient-5);
        opacity: .43;
        }

        .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {
        stroke-width: 0px;
        }

        .cls-1, .cls-8, .cls-6 {
        isolation: isolate;
        }

        .cls-2 {
        fill: url(#linear-gradient);
        }

        .cls-3 {
        fill: #00807c;
        }

        .cls-4 {
        fill: url(#linear-gradient-2);
        }

        .cls-5 {
        fill: url(#linear-gradient-3);
        }

        .cls-6 {
        fill: url(#linear-gradient-4);
        opacity: .44;
        }

        .cls-7, .cls-9 {
        fill: #fff;
        }

        .cls-9 {
        stroke: #fff;
        stroke-miterlimit: 10;
        }
      </svg:style>
      <linearGradient
        id="linear-gradient"
        x1="8.12"
        y1="1787.45"
        x2="26.4"
        y2="1776.68"
        gradientTransform="translate(0 -1763)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#8d8b00" />
        <stop offset=".1" stop-color="#91940e" />
        <stop offset=".28" stop-color="#9bac33" />
        <stop offset=".52" stop-color="#aad26d" />
        <stop offset=".54" stop-color="#acd673" />
        <stop offset=".56" stop-color="#aad26d" />
        <stop offset=".86" stop-color="#959f1f" />
        <stop offset="1" stop-color="#8d8b00" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="6.34"
        y1="1780.75"
        x2="23.73"
        y2="1770.51"
        gradientTransform="translate(0 -1763)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#3b6e8f" />
        <stop offset=".09" stop-color="#5487a0" />
        <stop offset=".33" stop-color="#99ccd0" />
        <stop offset=".45" stop-color="#b4e7e3" />
        <stop offset=".55" stop-color="#a3d6d7" />
        <stop offset=".75" stop-color="#77aab9" />
        <stop offset="1" stop-color="#3b6e8f" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="12.37"
        y1="1781.06"
        x2="19.58"
        y2="1776.86"
        gradientTransform="translate(0 -1763)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#e86d24" />
        <stop offset=".17" stop-color="#ed8232" />
        <stop offset=".53" stop-color="#fbb955" />
        <stop offset=".57" stop-color="#fcbe58" />
        <stop offset=".64" stop-color="#f9b956" />
        <stop offset=".73" stop-color="#eeac50" />
        <stop offset=".81" stop-color="#dd9545" />
        <stop offset=".91" stop-color="#c67637" />
        <stop offset="1" stop-color="#a84e25" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-4"
        x1="8.13"
        y1="1787.47"
        x2="26.41"
        y2="1776.7"
        gradientTransform="translate(0 -1763)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#404041" />
        <stop offset=".07" stop-color="#4e4e4f" />
        <stop offset=".19" stop-color="#737374" />
        <stop offset=".37" stop-color="#aeaeaf" />
        <stop offset=".54" stop-color="#f1f1f2" />
        <stop offset=".75" stop-color="#8f8d8e" />
        <stop offset=".92" stop-color="#413e3f" />
        <stop offset="1" stop-color="#231f20" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-5"
        x1="6.33"
        y1="1780.75"
        x2="23.79"
        y2="1770.59"
        gradientTransform="translate(0 -1763)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#231f20" />
        <stop offset=".51" stop-color="#a8a8a8" />
        <stop offset="1" stop-color="#000" />
      </linearGradient>
    </defs>
    <g id="Group_1183" data-name="Group 1183">
      <g id="Rectangle_3249" data-name="Rectangle 3249">
        <path class="cls-3" d="M16,0h48c8.84,0,16,7.16,16,16h0c0,8.84-7.16,16-16,16H16C7.16,32,0,24.84,0,16h0C0,7.16,7.16,0,16,0Z" />
      </g>
      <g id="TR" class="cls-8">
        <g class="cls-8">
          <path class="cls-7" d="M43.8,16.45h4.4v.08c0,1.83-.54,3.31-1.58,4.32-1.1,1.07-2.42,1.36-3.63,1.36-1.55,0-2.66-.45-3.63-1.46-1.04-1.07-1.58-2.5-1.58-4.03,0-1.67.67-3.11,1.55-3.99.91-.93,2.37-1.6,4.02-1.6.96,0,1.95.21,2.79.67.88.5,1.42,1.12,1.73,1.6l-1.3.91c-.32-.45-.8-.93-1.31-1.22-.59-.35-1.23-.46-1.89-.46-1.39,0-2.29.58-2.82,1.1-.7.71-1.14,1.84-1.14,2.99,0,1.07.4,2.15,1.1,2.9.74.78,1.65,1.07,2.67,1.07.93,0,1.7-.27,2.38-.94.59-.58.83-1.2.9-1.81h-2.66v-1.5Z" />
          <path class="cls-7" d="M52.15,11.32c1.3,0,2.13.16,2.82.62,1.17.78,1.26,2.05,1.26,2.51,0,1.54-.94,2.66-2.37,2.98l3.33,4.56h-1.97l-3.06-4.37h-.29v4.37h-1.63v-10.68h1.9ZM51.88,16.22h.51c.45,0,2.27-.05,2.27-1.75,0-1.5-1.42-1.65-2.22-1.65h-.56v3.39Z" />
          <path class="cls-7" d="M60.42,11.32v10.68h-1.63v-10.68h1.63Z" />
          <path class="cls-7" d="M65.34,11.32c.66,0,1.57.06,2.34.58.9.59,1.33,1.62,1.33,2.59,0,.62-.16,1.58-1.04,2.34-.85.72-1.82.83-2.61.83h-.74v4.34h-1.63v-10.68h2.35ZM64.62,16.16h.74c1.41,0,2.08-.69,2.08-1.68,0-.59-.24-1.65-2.1-1.65h-.72v3.33Z" />
        </g>
      </g>
    </g>
    <g>
      <circle
        class="cls-9"
        cx="16"
        cy="16"
        r="11.5"
      />
      <path class="cls-2" d="M26.98,16.29s-.22,5-3.6,7.75c-4.89,4.05-10.39,3.43-13.93.79-4.05-3.03-4.33-7.42-4.33-7.42,0,0,.73.67,2.14.56,2.08-.11,4.21-1.52,4.21-1.52,0,0,.11,1.57,1.29,2.47,1.63,1.24,3.93.73,5.23.06s2.92-1.91,5.11-2.87c2.53-1.01,3.88.17,3.88.17Z" />
      <path class="cls-4" d="M5.02,15.5s.17-4.44,2.98-7.08c5.45-5.23,11.91-3.43,14.5-1.4,3.99,3.15,4.38,7.42,4.38,7.42,0,0-.73-.67-2.14-.62-2.08.11-4.27,1.57-4.27,1.57,0,0-.06-1.07-.73-1.91-.62-.79-1.46-1.07-1.46-1.07l2.58-.39-.06-.39-2.58.22,2.19-2.02-.22-.28-2.25,1.8.34-2.98-.39-.06-.62,2.98-1.74-2.53-.39.22,1.63,2.58-2.92-.9-.11.34,2.7,1.07s-1.29.06-2.42.73c-1.24.73-2.92,2.02-5.06,2.92-2.58,1.01-3.93-.22-3.93-.22Z" />
      <path class="cls-5" d="M11.48,16.51s2.7-1.8,4.05-2.25c1.07-.39,2.3-.45,3.32-.06,1.01.34,1.57,1.24,1.57,1.24,0,0-1.24.84-2.42,1.46s-3.2,1.29-4.5.96c-1.24-.34-2.02-1.35-2.02-1.35Z" />
      <path class="cls-6" d="M23.05,16.18c-2.19.9-3.82,2.14-5.11,2.87-1.35.73-3.65,1.24-5.23-.06-1.18-.9-1.29-2.47-1.29-2.47,0,0-2.14,1.35-4.21,1.52-1.4.06-2.14-.56-2.14-.56,0,0,.28,4.38,4.33,7.42,3.54,2.64,9.05,3.26,13.93-.79,3.37-2.75,3.6-7.75,3.6-7.75,0,0-1.29-1.24-3.88-.17ZM22.77,23.87c-4.21,3.37-9.44,3.09-12.64.73-3.71-2.7-4.33-6.07-4.38-6.29,0,0,.22.39,1.69.28,1.91-.11,3.65-1.18,3.65-1.18,0,0,.11,1.24,1.63,2.19,1.8,1.12,4.27.56,5.45-.11,1.18-.62,2.81-1.85,4.72-2.75,2.42-1.12,3.54-.22,3.54-.22,0,0-.17,4.55-3.65,7.36Z" />
      <path class="cls-1" d="M15.69,11.74c-1.18.06-2.58,1.01-2.98,1.29-1.29.79-1.57,1.01-2.58,1.57-1.01.51-3.26,1.46-4.5.67.06-.96.51-4.5,3.09-6.85,2.47-2.25,5-2.98,7.92-2.92,3.71.06,5.9,2.08,7.02,3.2,1.24,1.24,2.36,3.93,2.53,4.78-.28-.28-1.97-.67-5.39,1.18-.17-.9-.84-1.97-1.85-2.36h0l-.62.11s.9.28,1.46,1.12c.62.84.73,1.91.73,1.91,0,0,2.19-1.4,4.27-1.57,1.4-.06,2.14.62,2.14.62,0,0-.39-4.27-4.38-7.42-2.58-2.02-9.1-3.82-14.5,1.4-2.81,2.64-3.03,7.02-3.03,7.02,0,0,1.29,1.24,3.88.17,2.19-.9,3.82-2.19,5.06-2.92,1.12-.67,2.42-.73,2.42-.73l-.67-.28Z" />
    </g>
  </svg>
</template>
